<div class="modal active">
  <div class="modal__container modal__container--sm">
      <div class="fields">
          <h2 *ngIf="!editMode">Create Layer</h2>
          <h2 *ngIf="editMode">Edit Layer</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
              <form autocomplete="off"  [formGroup]="configurationLayerForm" class="active" (ngSubmit)="saveLayer()">
                  <div class="fields__block">
                      <div class="fields__block__section">
                          <div class="input-fields">
                              <div><label for="">Name</label><input name="name" type="text" formControlName="name" [(ngModel)]="layer.name" maxlength="100"/></div>
                              <div><label for="">URL</label><input name="url" type="text" formControlName="url" [(ngModel)]="layer.path" maxlength="255"/></div>
                              <div><label for="">Type</label><select name="type" formControlName="type" [(ngModel)]="layer.type">
                                <!--<option *ngFor="let config of this.defaultConfigurations"> {{ config.name }}</option>-->
                                <option value="Base Map">Base Map</option>
                                <option value="Layer">Layer</option>
                                <option value="GeoJsonLayer">GeoJson Layer</option>
                                <option value="ImageLayer">Image Layer</option>
                              </select>
                            </div>
                              <div><label for="">Active</label><input name="active" type="checkbox" formControlName="active" [(ngModel)]="layer.enabled"/></div>
                          </div>
                      </div>
                  </div>
                  <div class="fields__btn">
                    <button type="submit" [ngClass]="configurationLayerForm.valid ? 'blue' : 'gray'" [disabled]="!configurationLayerForm.valid">Save</button>
                    <button type="button" class="gray" (click)="cancel()">Cancel</button>
                  </div>
              </form>
          </div>
      </div>
  </div>
</div>
